import Cars from "../components/Cars";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useContext, useEffect } from "react";
import { CarbonContext } from "../CarbonContext";
import { useNavigate } from "react-router-dom";
const AllCars = () => {
  const { token } = useContext(CarbonContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token.access_token) {
      navigate("/");
    }
  }, [token, navigate]);

  return (
    <>
      <Navbar />
      <Cars />
      <Footer />
    </>
  );
};

export default AllCars;
